var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "csp-base-file-upload",
    _vm._b(
      {
        ref: "fileUpload",
        attrs: {
          disabled: _vm.isDisabled,
          "file-input-name": "fileUpload",
          "multiple-upload": _vm.multipleUpload,
          "on-transform": _vm.onTransform,
          title: _vm.$t("record document upload"),
          "upload-error-message": this.$t("record document upload error"),
          "upload-url": _vm.uploadUrl,
        },
        on: {
          "before-upload": _vm.handleBeforeUpload,
          "file-drop": (event) => _vm.$emit("file-drop", event),
          "upload-complete": _vm.handleUploadComplete,
          "upload-disabled": _vm.handleDisabledUpload,
          "upload-reset": function ($event) {
            return _vm.$emit("upload-reset")
          },
        },
      },
      "csp-base-file-upload",
      _vm.fileDropOnlyProps,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }